import styled from '@emotion/styled';

import Typography from 'components/Typography';

export const TeammateBox = styled.div`
  max-width: ${({ theme }) => theme.maxWidth.xs};
  background-color: ${({ theme }) => theme.colors.secondary.white};
  box-shadow: ${({ theme }) => theme.boxShadow};
`;

export const Name = styled(Typography.body1)`
  font-size: 1.2rem;
  text-align: center;
  margin: 0.3rem;
`;

export const Position = styled.div`
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  min-height: 50px;
  color: ${({ theme }) => theme.colors.primary.orange};
`;
